import { useTranslation } from "react-i18next";
import { ContentPanel, PageBanner, UnorderedList } from "../components";
import { MedicalLogisticalServicesBanner } from "../images";
import { ContactUsButton } from "../components/ContactUsButton/ContactUsButton";

type pageList = {
    title: string;
    list: []
}

export const OccupationalHealthServices = () => {
    const { t } = useTranslation();
    const keyCapabilities1 = t('occupationalHealthServices.keyCapabilities1.list', { returnObjects: true })
    const keyCapabilities2 = t('occupationalHealthServices.keyCapabilities1.list', { returnObjects: true })

    const pageList = t('occupationalHealthServices.pageList', { returnObjects: true }) as Array<pageList>

    return (
        <div>
            <PageBanner image={MedicalLogisticalServicesBanner} title={t('occupationalHealthServices.bannerTitle')} />

            <ContentPanel headerText={t('occupationalHealthServices.header')}>
                <p className="mb-5">{t('occupationalHealthServices.paragraph1')}</p>

                <h4 className="text-xl mb-5">{t('occupationalHealthServices.subHeader')}</h4>

                {pageList.map((item) => (
                    <>
                        <h4 className="text-xl my-5">{item.title}</h4>
                        <UnorderedList items={item.list} hasCheckmark={false} />
                    </>
                ))}

                <ContactUsButton title={t('occupationalHealthServices.contactUsTitle')} />
            </ContentPanel>
        </div>
    )
}